import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Promo from "../components/common/Promobar";

export default function AuthLayout({ children }) {
  return (
    <div className="storefront-typography min-h-screen bg-gray-50 flex flex-col">
      <Promo/>
      <Navbar />

      <main className="flex-1">
        {children}
      </main>

      <Footer />
    </div>
  );
}
